import { environment } from '../../../environments/environment';

export const storageKey = `${environment.namespace}_${environment.environment}_state`;
